// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gUR2","colBig":"styles_colBig__1qZT4","colSmall":"styles_colSmall__A_AG4"};